import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import MehndiCountdown from "./components/MehndiCountDown"; // Different timer for Mehndi
import ReceptionCountdown from "./components/ReceptionCountDown"; // Different timer for Reception
import MehndiRSVPForm from "./components/MehndiRsvpForm"; // Different RSVP for Mehndi
import ReceptionRSVPForm from "./components/ReceptionRsvpForm"; // Different RSVP for Reception

function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="home-container">
          <div className="image-container">
            <img src="couple2.png" alt="Couple" className="couple-image" />
          </div>
        </div>
      </header>
    </div>
  );
}

function MehndiPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        <div className="home-container">
          <div className="countdown-timer-container">
            <MehndiCountdown />
          </div>
          <div className="rsvp-button-container">
            <button className="rsvp-button" onClick={() => setIsModalOpen(true)}>RSVP for Mehndi</button>
          </div>
          <div className="image-container">
            <img src="couple2.png" alt="Couple" className="couple-image" />
          </div>
        </div>
      </header>
      <MehndiRSVPForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

function ReceptionPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        <div className="home-container">
          <div className="countdown-timer-container">
            <ReceptionCountdown />
          </div>
          <div className="rsvp-button-container">
            <button className="rsvp-button" onClick={() => setIsModalOpen(true)}>RSVP for Reception</button>
          </div>
          <div className="image-container">
            <img src="couple2.png" alt="Couple" className="couple-image" />
          </div>
        </div>
      </header>
      <ReceptionRSVPForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mehndi" element={<MehndiPage />} />
        <Route path="/reception" element={<ReceptionPage />} />
      </Routes>
    </Router>
  );
}

export default App;




